import { Button, Dropdown, Menu } from "antd";
import React from "react";
import styles from "./TNDropDown.module.scss";

type MenuItemType = {
  label: string;
  onClick: () => void;
};

interface TNDropDownProps {
  text?: string;
  type?: string;
  disabled?: boolean;
  position?: string;
  menuItems?: MenuItemType[];
}

export const TNDropDown: React.FC = (props: TNDropDownProps) => {
  const { text, type, menuItems, position, disabled } = props;
  const items = (
    <Menu>
      {menuItems?.map((item, index) => (
        <Menu.Item key={index} onClick={item.onClick}>
          {item.label}
        </Menu.Item>
      ))}
    </Menu>
  );
  return (
    <Dropdown
      overlay={items}
      placement={position}
      align={{ offset: [0, 0] }}
      disabled={disabled}
    >
      <Button className={styles.tnButton} type={type}>
        {text}
      </Button>
    </Dropdown>
  );
};
